export default __webpack_public_path__ + "static/media/start_icon.dde301fe.svg";